
export interface RuleSettings {
  maxDepth: number;
  suggested: boolean;
}